import { render } from "./PreviousJobCard.vue?vue&type=template&id=a45aa900"
import script from "./PreviousJobCard.vue?vue&type=script&lang=js"
export * from "./PreviousJobCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__